import { render, staticRenderFns } from "./tronscanCollection.vue?vue&type=template&id=a9a5e52e&scoped=true"
import script from "./tronscanCollection.vue?vue&type=script&lang=js"
export * from "./tronscanCollection.vue?vue&type=script&lang=js"
import style0 from "./tronscanCollection.vue?vue&type=style&index=0&id=a9a5e52e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a5e52e",
  null
  
)

export default component.exports